import { E_ColoriMetallo, E_KitLedOmbrelloni, E_MainLato, E_MisureOmbrelloni, E_PedanaRivestimento, E_PedanaStepAltezza, E_TipoOmbrellone, E_TipoParavento } from "../components/Utils/enumerations";

// Code by MANUEL CANAZZA
let importoTotale = 0;
let perimetro = 0;
let area = 0;
let costoSottoscocca = 0;
let costoRivestimento = 0;  
let costoMinigonna = 0;  
let costoRampaDisabili = 0;  
let costoPredParaventi = 0;
let costoParaventi = 0;
let costoPorteParaventi = 0;
let costoBotole = 0;
let costoPredisposizioneOmbrelloni = 0;
let costoOmbrelloni = 0;
let costoOmbrellonisuMisura = 0;
let costoNastraturaCuciture = 0;
let costoGrondaie = 0;
let costoVelcro = 0;
let costoCristal = 0; 
let costoSostegniCristal = 0;
let costoKitPorta = 0;
let costoLed = 0;
let ombrelloneSuMisura = false;

const Clear = () => {
  importoTotale = 0;
  perimetro = 0;
  area = 0;  
  costoSottoscocca = 0;
  costoRivestimento = 0;  
  costoMinigonna = 0;  
  costoRampaDisabili = 0;  
  costoPredParaventi = 0;
  costoParaventi = 0;
  costoPorteParaventi = 0;
  costoBotole = 0;
  costoPredisposizioneOmbrelloni = 0;
  costoOmbrelloni = 0;
  costoOmbrellonisuMisura = 0;
  costoNastraturaCuciture = 0;
  costoGrondaie = 0;
  costoVelcro = 0;
  costoCristal = 0; 
  costoSostegniCristal = 0;
  costoKitPorta = 0;
  costoLed = 0;
  ombrelloneSuMisura = false;
};

const calculatePedanaTotal = (area, perimetro, stepAltezza, rivestimento, hasMinigonna, hasRampaDisabili, hasPredParaventi, botole, lunghezzaParaventi) => {
    // Step altezza   
    switch (stepAltezza.toString()) {     
      case E_PedanaStepAltezza.Da0a50.toString():
        costoSottoscocca = 0 * area;
        break;
      case E_PedanaStepAltezza.Da50a95.toString():
        costoSottoscocca = 171.5 * area;
        break;
      case E_PedanaStepAltezza.Da95a125.toString():
        costoSottoscocca = 204 * area;
        break;
      case E_PedanaStepAltezza.Da125a250.toString():
        costoSottoscocca = 238 * area;
        break;
      default:
        break;
    }   
    // Rivestimento
    switch (rivestimento.toString()) { 
      case E_PedanaRivestimento.WPC.toString():
        costoRivestimento = 243 * area;
        break;
      case E_PedanaRivestimento.ANGELIM.toString():
        costoRivestimento = 168 * area;
        break;
      default:
        break;
    }
    // Minigonna
    switch (hasMinigonna) {
      case true:
        costoMinigonna = 50 * perimetro;
        break;
      case false:
        costoMinigonna = 0 * perimetro;
        break;
      default:
        break;
    }
    // Rampa
    switch (hasRampaDisabili) {
      case true:
        costoRampaDisabili = 855;
        break;
      case false:
        costoRampaDisabili = 0;
        break;
      default:
        break;
    }
    // Pred paravento
    switch (hasPredParaventi) {
      case true:
        costoPredParaventi = 50.5 * lunghezzaParaventi;
        break;
      case false:
        costoPredParaventi = 0 * lunghezzaParaventi;
        break;
      default:
        break;
    }
    // Botola
    switch (botole * 1) {
    case 0:
      costoBotole = 0 * 419.5;
      break;
    case 1:
      costoBotole = 1 * 419.5;
      break;
    case 2:
      costoBotole = 2 * 419.5;
      break;
    case 3:
      costoBotole = 3 * 419.5;
      break;
    default:
      break;
  }    
  return costoSottoscocca + costoRivestimento + costoMinigonna + costoRampaDisabili + costoPredParaventi + costoBotole;
}

const calculateParaventiTotal = (lunghezzaParaventi, tipoParaventi, porteParaventi) => {
  // PARAVENTI  
  switch (tipoParaventi.toString()) {    
    case E_TipoParavento.Slim_100.toString():
      costoParaventi = 455 * lunghezzaParaventi;
      break;
    case E_TipoParavento.Unico_100.toString():
      costoParaventi = 498 * lunghezzaParaventi;
      break;
    case E_TipoParavento.Unico_150.toString():
      costoParaventi = 715 * lunghezzaParaventi;
      break;
    case E_TipoParavento.Smeraldo.toString():
      costoParaventi = 596.5 * lunghezzaParaventi;
      break;
    case E_TipoParavento.Rubino.toString():
      costoParaventi = 654 * lunghezzaParaventi;
      break;
    case E_TipoParavento.Topazio.toString():
      costoParaventi = 642.5 * lunghezzaParaventi;
      break;
    case E_TipoParavento.Screen_Up_100.toString():
      costoParaventi = 0 * lunghezzaParaventi;
      break;
    default:
      break;
  }  
  // Kit Porta
  switch (porteParaventi * 1) { 
    case 0:
      costoPorteParaventi = 0 * 937;
      break;
    case 1:
      costoPorteParaventi = 1 * 937;
      break;
    case 2:
      costoPorteParaventi = 2 * 937;
      break;
    default:
      break;
  } 
  return costoParaventi + costoPorteParaventi; 
}

const calculateOmbrelloniTotal = (numeroOmbrelloni, tipoOmbrelloni, hasBase, misureOmbrelloni, hasGrondaie, hasNastratura, hasVelcro, hasMisuraAutomatica, data, coloreMetallo, lunghezzaParavento, hasLed, tipoKitLed, hasDimmerTel, ombrelloniNumeroGrondaie) => {
  // Calcola il numero di grondaie
  let numeroGrondaie = ombrelloniNumeroGrondaie;
  if (numeroGrondaie < 0) {
    numeroGrondaie = 0;
  }
  // Verifica se l'ombrellone è su misura
  if (hasMisuraAutomatica && data.length > 0 && data[0].realDimension > data[0].mainDimension) {  
    ombrelloneSuMisura = true;
  } 
  // OMBRELLONI    
  if (numeroOmbrelloni > 0) {      
    costoPredisposizioneOmbrelloni = !hasBase && 804 * numeroOmbrelloni;          
    if (tipoOmbrelloni.toString() !== E_TipoOmbrellone.Scegli.toString() && misureOmbrelloni.toString() !== E_MisureOmbrelloni.Scegli.toString()) {
      switch (tipoOmbrelloni.toString()) {
        case E_TipoOmbrellone.Avantage.toString(): {  
          const percentageSuMisura = 0.30;
          switch (misureOmbrelloni.toString()) {             
            case E_MisureOmbrelloni._3X3.toString():   
              costoOmbrelloni = !hasBase ? numeroOmbrelloni * 2633.0 : numeroOmbrelloni * (2633.0 + 298.5);
              // Nastratura / Cuciture
              if (hasNastratura) {
                costoNastraturaCuciture = 263;
              }
              // Grondaie
              if (hasGrondaie) {
                costoGrondaie = numeroGrondaie * 3 * 57.5;
              } 
              // Su misura
              if (ombrelloneSuMisura) {
                costoOmbrellonisuMisura = !hasBase ? numeroOmbrelloni * (2668.0 + (2668.0 * percentageSuMisura)) : numeroOmbrelloni * (2668.0 + 298.5 + ((2668.0 + 298.5) * percentageSuMisura));
              } 
            break;
            case E_MisureOmbrelloni._3mX3m.toString():
              costoOmbrelloni = !hasBase ? numeroOmbrelloni * 2668.0 : numeroOmbrelloni * (2668.0 + 298.5);
              // Nastratura / Cuciture
              if (hasNastratura) {
                costoNastraturaCuciture = 263;
              }  
              // Grondaie
              if (hasGrondaie) {
                costoGrondaie = numeroGrondaie * 3.5 * 57.5;
              }  
              // Su misura
              if (ombrelloneSuMisura) {
                costoOmbrellonisuMisura = !hasBase ? numeroOmbrelloni * (3061.5 + (3061.5 * percentageSuMisura)) : numeroOmbrelloni * ((3061.5 + 298.5) + ((3061.5 + 298.5) * percentageSuMisura));
              } 
            break;
            case E_MisureOmbrelloni._4X4.toString():
              costoOmbrelloni = !hasBase ? numeroOmbrelloni * 3727.5 : numeroOmbrelloni * (3727.5 + 298.5);
              // Nastratura / Cuciture
              if (hasNastratura) {
                costoNastraturaCuciture = 263;
              }  
              // Grondaie
              if (hasGrondaie) {
                costoGrondaie = numeroGrondaie * 4 * 57.5;
              }
              // Su misura
              if (ombrelloneSuMisura) {
                costoOmbrellonisuMisura = !hasBase ? numeroOmbrelloni * 3727.5 : numeroOmbrelloni * (3727.5 + 298.5);
              }   
            break;
            case E_MisureOmbrelloni._2X3.toString():
              costoOmbrelloni = !hasBase ? numeroOmbrelloni * 2440.0 : numeroOmbrelloni * (2440.0 + 298.5);
              // Nastratura / Cuciture
              if (hasNastratura) {
                costoNastraturaCuciture = 174;
              }  
              // Grondaie
              if (hasGrondaie) {
                costoGrondaie = numeroGrondaie * 2 * 57.5;
              } 
              // Su misura
              if (ombrelloneSuMisura) {
                costoOmbrellonisuMisura = !hasBase ? numeroOmbrelloni * (2633.0 + (2633.0 * percentageSuMisura)) : numeroOmbrelloni * ((2633.0 + 298.5) + ((2633.0 + 298.5) * percentageSuMisura));
              }  
            break;
            case E_MisureOmbrelloni._3X4.toString():
              costoOmbrelloni = !hasBase ? numeroOmbrelloni * 3061.5 : numeroOmbrelloni * (3061.5 + 298.5);
              // Nastratura / Cuciture
              if (hasNastratura) {
                costoNastraturaCuciture = 263;
              }  
              // Grondaie
              if (hasGrondaie) {
                costoGrondaie = numeroGrondaie * 3 * 57.5;  
              }  
              // Su misura
              if (ombrelloneSuMisura) {
                costoOmbrellonisuMisura = !hasBase ? numeroOmbrelloni * (3727.5 + (3727.5 * percentageSuMisura)) : numeroOmbrelloni * ((3727.5 + 298.5) + ((3727.5 + 298.5) * percentageSuMisura));
              }  
            break;         
          }  
        }  
        break;        
        case E_TipoOmbrellone.DeLuxe.toString(): {
          const percentageSuMisura = 0.20;
          switch (misureOmbrelloni.toString()) {
            case E_MisureOmbrelloni._3X3.toString():         
              costoOmbrelloni = !hasBase ? numeroOmbrelloni * 1993.0 : numeroOmbrelloni * (1993.0 + 205);
              // Nastratura / Cuciture
              if (hasNastratura) {
                costoNastraturaCuciture = 263;
              } 
              // Grondaie
              if (hasGrondaie) {
                costoGrondaie = numeroGrondaie * 3 * 57.5;    
              }  
              // Su misura
              if (ombrelloneSuMisura) {
                costoOmbrellonisuMisura = !hasBase ? numeroOmbrelloni * (2385.5 + (2385.5 * percentageSuMisura)) : numeroOmbrelloni * ((2385.5 + 205) + ((2385.5 + 205) * percentageSuMisura));
              }   
            break;
            case E_MisureOmbrelloni._3mX3m.toString():
              costoOmbrelloni = !hasBase ? numeroOmbrelloni * 2867.0 : numeroOmbrelloni * (2867.0 + 205);
              // Nastratura / Cuciture
              if (hasNastratura) {
                costoNastraturaCuciture = 263;
              } 
              // Grondaie
              if (hasGrondaie) {
                costoGrondaie = numeroGrondaie * 3.5 * 57.5;
              }
              // Su misura
              if (ombrelloneSuMisura) {
                costoOmbrellonisuMisura = !hasBase ? numeroOmbrelloni * (3034.0 + (3034.0 * percentageSuMisura)) : numeroOmbrelloni * ((3034.0 + 205) + ((3034.0 + 205) * percentageSuMisura));
              }     
            break;
            case E_MisureOmbrelloni._4X4.toString():
              costoOmbrelloni = !hasBase ? numeroOmbrelloni * 3034.0 : numeroOmbrelloni * (3034.0 + 205);
              // Nastratura / Cuciture
              if (hasNastratura) {
              costoNastraturaCuciture = 263;
              }  
              // Grondaie
              if (hasGrondaie) {
                costoGrondaie = numeroGrondaie * 4 * 57.5;
              }
              // Su misura
              if (ombrelloneSuMisura) {
                costoOmbrellonisuMisura = !hasBase ? numeroOmbrelloni * (5140.0 + (5140.0 * percentageSuMisura)) : numeroOmbrelloni * ((5140.0 + 205) + ((5140.0 + 205) * percentageSuMisura));
              }    
            break;
            case E_MisureOmbrelloni._2X3.toString():
              costoOmbrelloni = !hasBase ? numeroOmbrelloni * 1913.5 : numeroOmbrelloni * (1913.5 + 205);
              // Nastratura / Cuciture
              if (hasNastratura) {
                costoNastraturaCuciture = 263;
              }  
              // Grondaie
              if (hasGrondaie) {
                costoGrondaie = numeroGrondaie * 2 * 57.5;
              }  
              // Su misura
              if (ombrelloneSuMisura) {
                costoOmbrellonisuMisura = !hasBase ? numeroOmbrelloni * (1993.0 + (1993.0 * percentageSuMisura)) : numeroOmbrelloni * ((1993.0 + 205) + ((1993.0 + 205) * percentageSuMisura));
              }  
            break;
            case E_MisureOmbrelloni._3X4.toString():
              costoOmbrelloni = !hasBase ? numeroOmbrelloni * 2385.5 : numeroOmbrelloni * (2385.5 + 205);
              // Nastratura / Cuciture
              if (hasNastratura) {
                costoNastraturaCuciture = 263;
              } 
              // Grondaie
              if (hasGrondaie) {
                costoGrondaie = numeroGrondaie * 3 * 57.5;  
              } 
              // Su misura
              if (ombrelloneSuMisura) {
                costoOmbrellonisuMisura = !hasBase ? numeroOmbrelloni * (2640.5 + (2640.5 * percentageSuMisura)) : numeroOmbrelloni * ((2640.5 + 205) + ((2640.5 + 205) * percentageSuMisura));
              }    
            break;    
            case E_MisureOmbrelloni._3X5.toString():
              costoOmbrelloni = !hasBase ? numeroOmbrelloni * 2640.5 : numeroOmbrelloni * (2640.5 + 205);
              // Nastratura / Cuciture
              if (hasNastratura) {
                costoNastraturaCuciture = 531;
              } 
              // Grondaie
              if (hasGrondaie) {
                costoGrondaie = numeroGrondaie * 3 * 57.5;
              }
              // Su misura
              if (ombrelloneSuMisura) {
                costoOmbrellonisuMisura = !hasBase ? numeroOmbrelloni * (2867.0 + (2867.0 * percentageSuMisura)) : numeroOmbrelloni * ((2867.0 + 205) + ((2867.0 + 205) * percentageSuMisura));
              }     
            break;      
            case E_MisureOmbrelloni._4X5.toString():
              costoOmbrelloni = !hasBase ? numeroOmbrelloni * 5140.5 : numeroOmbrelloni * (5140.5 + 205);
              // Nastratura / Cuciture
              if (hasNastratura) {
                costoNastraturaCuciture = 458;
              }  
              // Grondaie
              if (hasGrondaie) {
                costoGrondaie = numeroGrondaie * 4 * 57.5;
              } 
              // Su misura
              if (ombrelloneSuMisura) {
                costoOmbrellonisuMisura = !hasBase ? numeroOmbrelloni *  5140.5 : numeroOmbrelloni * (5140.5 + 205);
              }   
            break;           
          }  
        }   
        break;     
        case E_TipoOmbrellone.Facility.toString(): {
          const percentageSuMisura = 0.20;
          switch (misureOmbrelloni.toString()) {
            case E_MisureOmbrelloni._3X3.toString():         
              costoOmbrelloni = !hasBase ? numeroOmbrelloni * 1000.0 : numeroOmbrelloni * (1000.0 + 108.5);
              // Nastratura / Cuciture
              if (hasNastratura) {
                costoNastraturaCuciture = 263;
              } 
              // Grondaie
              if (hasGrondaie) {
                costoGrondaie = numeroGrondaie * 3 * 57.5;  
              }
              // Su misura
              if (ombrelloneSuMisura) {
                costoOmbrellonisuMisura = !hasBase ? numeroOmbrelloni * (1100.0 + (1100.0 * percentageSuMisura)) : numeroOmbrelloni * ((1100.0 + 108.5) + ((1100.0 + 108.5) * percentageSuMisura));
              }       
            break;
            case E_MisureOmbrelloni._3X4.toString():
              costoOmbrelloni = !hasBase ? numeroOmbrelloni * 1100.0 : numeroOmbrelloni * (1100.0 + 108.5);
              // Nastratura / Cuciture
              if (hasNastratura) {
                costoNastraturaCuciture = 263;
              } 
              // Grondaie
              if (hasGrondaie) {
                costoGrondaie = numeroGrondaie * 3 * 57.5;  
              }
              // Su misura
              if (ombrelloneSuMisura) {
                costoOmbrellonisuMisura = !hasBase ? numeroOmbrelloni * (1190.0 + (1190.0 * percentageSuMisura)) : numeroOmbrelloni * ((1190.0 + 108.5) + ((1190.0 + 108.5) * percentageSuMisura));
              }       
            break;
            case E_MisureOmbrelloni._3mX3m.toString():
              costoOmbrelloni = !hasBase ? numeroOmbrelloni * 1190.0 : numeroOmbrelloni * (1190.0 + 108.5);
              // Nastratura / Cuciture
              if (hasNastratura) {
                costoNastraturaCuciture = 263;
              } 
              // Grondaie
              if (hasGrondaie) {
                costoGrondaie = numeroGrondaie * 3 * 57.5;  
              }
              // Su misura
              if (ombrelloneSuMisura) {
                costoOmbrellonisuMisura = !hasBase ? numeroOmbrelloni * (1360.0 + (1360.0 * percentageSuMisura)) : numeroOmbrelloni * ((1360.0 + 108.5) + ((1360.0 + 108.5) * percentageSuMisura));
              }       
            break;
            case E_MisureOmbrelloni._4X4.toString():
              costoOmbrelloni = !hasBase ? numeroOmbrelloni * 1360.0 : numeroOmbrelloni * (1360.0 + 108.5);
              // Nastratura / Cuciture
              if (hasNastratura) {
                costoNastraturaCuciture = 263;
              }  
              // Grondaie
              if (hasGrondaie) {
                costoGrondaie = numeroGrondaie * 4 * 57.5;  
              }             
              // Su misura
              if (ombrelloneSuMisura) {
                costoOmbrellonisuMisura = !hasBase ? numeroOmbrelloni * (2004.5 + (2004.5 * percentageSuMisura)) : numeroOmbrelloni * ((2004.5 + 108.5) + ((2004.5 + 108.5) * percentageSuMisura));
              }      
            break;
            case E_MisureOmbrelloni._3X5.toString():
              costoOmbrelloni = !hasBase ? numeroOmbrelloni * 2004.5 : numeroOmbrelloni * (2004.5 + 108.5);
              // Nastratura / Cuciture
              if (hasNastratura) {
                costoNastraturaCuciture = 351;
              } 
              // Grondaie
              if (hasGrondaie) {
                costoGrondaie = numeroGrondaie * 3 * 57.5;  
              } 
              // Su misura
              if (ombrelloneSuMisura) {
                costoOmbrellonisuMisura = !hasBase ? numeroOmbrelloni * 2004.5 : numeroOmbrelloni * (2004.5 + 108.5);
              }      
            break;             
          }  
        }    
        break;    
        case E_TipoOmbrellone.Mezzombra.toString(): {
          const percentageSuMisura = 0.30;
          switch (misureOmbrelloni.toString()) {
            case E_MisureOmbrelloni._1mX3.toString():         
              costoOmbrelloni = !hasBase ? numeroOmbrelloni * 811.0 : numeroOmbrelloni * (811.0 + 116.5);
              // Nastratura / Cuciture
              if (hasNastratura) {
                costoNastraturaCuciture = 174;
              } 
              // Grondaie
              if (hasGrondaie) {
                costoGrondaie = numeroGrondaie * 1.5 * 57.5;  
              }
              // Su misura
              if (ombrelloneSuMisura) {
                costoOmbrellonisuMisura = !hasBase ? numeroOmbrelloni * (975.5 + (975.5 * percentageSuMisura)) : numeroOmbrelloni * ((975.5 + 116.5) + ((975.5 + 116.5) * percentageSuMisura));
              }      
            break;
            case E_MisureOmbrelloni._2X4.toString():
              costoOmbrelloni = !hasBase ? numeroOmbrelloni * 1106.5 : numeroOmbrelloni * (1106.5 + 116.5);
              // Nastratura / Cuciture
              if (hasNastratura) {
                costoNastraturaCuciture = 263;
              } 
              // Grondaie
              if (hasGrondaie) {
                costoGrondaie = numeroGrondaie * 2 * 57.5;  
              }
              // Su misura
              if (ombrelloneSuMisura) {
                costoOmbrellonisuMisura = !hasBase ? numeroOmbrelloni * 1106.5 : numeroOmbrelloni * (1106.5 + 116.5);
              }      
            break;
            case E_MisureOmbrelloni._1mX2.toString():
              costoOmbrelloni = !hasBase ? numeroOmbrelloni * 675.5 : numeroOmbrelloni * (675.5 + 116.5);
              // Nastratura / Cuciture
              if (hasNastratura) {
                costoNastraturaCuciture = 174;
              }  
              // Grondaie
              if (hasGrondaie) {
                costoGrondaie = numeroGrondaie * 1.5 * 57.5;  
              }
              // Su misura
              if (ombrelloneSuMisura) {
                costoOmbrellonisuMisura = !hasBase ? numeroOmbrelloni * (686.5 + (686.5 * percentageSuMisura)) : numeroOmbrelloni * ((686.5 + 116.5) + ((686.5 + 116.5) * percentageSuMisura));
              }     
            break;
            case E_MisureOmbrelloni._2X2.toString():
              costoOmbrelloni = !hasBase ? numeroOmbrelloni * 975.5 : numeroOmbrelloni * (975.5 + 116.5);
              // Nastratura / Cuciture
              if (hasNastratura) {
                costoNastraturaCuciture = 263;
              } 
              // Grondaie
              if (hasGrondaie) {
                costoGrondaie = numeroGrondaie * 2 * 57.5;    
              }
              // Su misura
              if (ombrelloneSuMisura) {
                costoOmbrellonisuMisura = !hasBase ? numeroOmbrelloni * (1044.5 + (1044.5 * percentageSuMisura)) : numeroOmbrelloni * ((1044.5 + 116.5) + ((1044.5 + 116.5) * percentageSuMisura));
              }      
            break;
            case E_MisureOmbrelloni._2X3.toString():
              costoOmbrelloni = !hasBase ? numeroOmbrelloni * 975.5 : numeroOmbrelloni * (975.5 + 116.5);
              // Nastratura / Cuciture
              if (hasNastratura) {
                costoNastraturaCuciture = 263;
              } 
              // Grondaie
              if (hasGrondaie) {
                costoGrondaie = numeroGrondaie * 2 * 57.5;    
              }
              // Su misura
              if (ombrelloneSuMisura) {
                costoOmbrellonisuMisura = !hasBase ? numeroOmbrelloni * (1044.5 + (1044.5 * percentageSuMisura)) : numeroOmbrelloni * ((1044.5 + 116.5) + ((1044.5 + 116.5) * percentageSuMisura));
              }      
            break;    
            case E_MisureOmbrelloni._1X3.toString():
              costoOmbrelloni = !hasBase ? numeroOmbrelloni * 686.5 : numeroOmbrelloni * (686.5 + 116.5);
              // Nastratura / Cuciture
              if (hasNastratura) {
                costoNastraturaCuciture = 174;
              }
              // Grondaie
              if (hasGrondaie) {
                costoGrondaie = numeroGrondaie * 1 * 57.5;   
              } 
              // Su misura
              if (ombrelloneSuMisura) {
                costoOmbrellonisuMisura = !hasBase ? numeroOmbrelloni * (811.0 + (811.0 * percentageSuMisura)) : numeroOmbrelloni * ((811.0 + 116.5) + ((811.0 + 116.5) * percentageSuMisura));
              }      
            break;      
            case E_MisureOmbrelloni._1mX4.toString():
              costoOmbrelloni = !hasBase ? numeroOmbrelloni * 1044.0 : numeroOmbrelloni * (1044.0 + 116.5);
              // Nastratura / Cuciture
              if (hasNastratura) {
                costoNastraturaCuciture = 263;
              } 
              // Grondaie
              if (hasGrondaie) {
                costoGrondaie = numeroGrondaie * 1.5 * 57.5;  
              }
              // Su misura
              if (ombrelloneSuMisura) {
                costoOmbrellonisuMisura = !hasBase ? numeroOmbrelloni * (1106.5 + (1106.5 * percentageSuMisura)) : numeroOmbrelloni * ((1106.5 + 116.5) + ((1106.5 + 116.5) * percentageSuMisura));
              }      
            break;           
          }  
        }     
        break;
        case E_TipoOmbrellone.PlatinoBasic.toString(): {
          const percentageSuMisura = 0.20;
          switch (misureOmbrelloni.toString()) {
            case E_MisureOmbrelloni._4X4.toString():         
              costoOmbrelloni = !hasBase ? numeroOmbrelloni * 3178.0 : numeroOmbrelloni * (3178.0 + 497);
              // Nastratura / Cuciture
              if (hasNastratura) {
                costoNastraturaCuciture = 263;
              }  
              // Grondaie
              if (hasGrondaie) {
                costoGrondaie = numeroGrondaie * 4 * 57.5;  
              } 
              // Su misura
              if (ombrelloneSuMisura) {
                costoOmbrellonisuMisura = !hasBase ? numeroOmbrelloni * (3339.5 + (3339.5 * percentageSuMisura)) : numeroOmbrelloni * ((3339.5 + 497) + ((3339.5 + 497) * percentageSuMisura));
              }       
            break;
            case E_MisureOmbrelloni._4mX4m.toString():
              costoOmbrelloni = !hasBase ? numeroOmbrelloni * 3339.5 : numeroOmbrelloni * (3339.5 + 497);
              // Nastratura / Cuciture
              if (hasNastratura) {
                costoNastraturaCuciture = 351;
              }  
              // Grondaie
              if (hasGrondaie) {
                costoGrondaie = numeroGrondaie * 4.5 * 57.5;    
              }
              // Su misura
              if (ombrelloneSuMisura) {
                costoOmbrellonisuMisura = !hasBase ? numeroOmbrelloni * (3419.0 + (3419.0 * percentageSuMisura)) : numeroOmbrelloni * ((3419.0 + 497) + ((3419.0 + 497) * percentageSuMisura));
              }        
            break;
            case E_MisureOmbrelloni._5X5.toString():
              costoOmbrelloni = !hasBase ? numeroOmbrelloni * 3660.5 : numeroOmbrelloni * (3660.5 + 497);
              // Nastratura / Cuciture
              if (hasNastratura) {
                costoNastraturaCuciture = 351;
              } 
              // Grondaie
              if (hasGrondaie) {
                costoGrondaie = numeroGrondaie * 5 * 57.5;  
              }
              // Su misura
              if (ombrelloneSuMisura) {
                costoOmbrellonisuMisura = !hasBase ? numeroOmbrelloni * 3660.5 : numeroOmbrelloni * (3660.5 + 497);
              }         
            break;
            case E_MisureOmbrelloni._3X5.toString():
              costoOmbrelloni = !hasBase ? numeroOmbrelloni * 3419.0 : numeroOmbrelloni * (3419.0 + 497);
              // Nastratura / Cuciture
              if (hasNastratura) {
                costoNastraturaCuciture = 351;
              }  
              // Grondaie
              if (hasGrondaie) {
                costoGrondaie = numeroGrondaie * 3 * 57.5;    
              }
              // Su misura
              if (ombrelloneSuMisura) {
                costoOmbrellonisuMisura = !hasBase ? numeroOmbrelloni * (3500.0 + (3500.0 * percentageSuMisura)) : numeroOmbrelloni * ((3500.0 + 497) + ((3500.0 + 497) * percentageSuMisura));
              }        
            break;
            case E_MisureOmbrelloni._4X5.toString():
              costoOmbrelloni = !hasBase ? numeroOmbrelloni * 3500.0 : numeroOmbrelloni * (3500.0 + 497);
              // Nastratura / Cuciture
              if (hasNastratura) {
                costoNastraturaCuciture = 438;
              } 
              // Grondaie
              if (hasGrondaie) {
                costoGrondaie = numeroGrondaie * 4 * 57.5;
              }
              // Su misura
              if (ombrelloneSuMisura) {
                costoOmbrellonisuMisura = !hasBase ? numeroOmbrelloni * (3660.5 + (3660.5 * percentageSuMisura)) : numeroOmbrelloni * ((3660.5 + 497) + ((3660.5 + 497) * percentageSuMisura));
              }         
            break;                
          }    
        }     
        break; 
        case E_TipoOmbrellone.PlatinoMedium.toString(): {
          const percentageSuMisura = 0.20;
          switch (misureOmbrelloni.toString()) {
            case E_MisureOmbrelloni._5X5.toString():         
              costoOmbrelloni = !hasBase ? numeroOmbrelloni * 3740.0 : numeroOmbrelloni * (3740.0 + 497);
              // Nastratura / Cuciture
              if (hasNastratura) {
                costoNastraturaCuciture = 351;
              }  
              // Grondaie
              if (hasGrondaie) {
                costoGrondaie = numeroGrondaie * 5 * 57.5;  
              }
              // Su misura
              if (ombrelloneSuMisura) {
                costoOmbrellonisuMisura = !hasBase ? numeroOmbrelloni * (4150.0 + (4150.0 * percentageSuMisura)) : numeroOmbrelloni * ((4150.0 + 497) + ((4150.0 + 497) * percentageSuMisura));
              }       
            break;
            case E_MisureOmbrelloni._5mX5m.toString():
              costoOmbrelloni = !hasBase ? numeroOmbrelloni * 4360.0 : numeroOmbrelloni * (4360.0 + 497);
              // Nastratura / Cuciture
              if (hasNastratura) {
                costoNastraturaCuciture = 380;
              }  
              // Grondaie
              if (hasGrondaie) {
                costoGrondaie = numeroGrondaie * 5.5 * 57.5;  
              }
              // Su misura
              if (ombrelloneSuMisura) {
                costoOmbrellonisuMisura = !hasBase ? numeroOmbrelloni * (4450.0 + (4450.0 * percentageSuMisura)) : numeroOmbrelloni * ((4450.0 + 497) + ((4450.0 + 497) * percentageSuMisura));
              }     
            break;
            case E_MisureOmbrelloni._6X6.toString():
              costoOmbrelloni = !hasBase ? numeroOmbrelloni * 4620.5 : numeroOmbrelloni * (4620.5 + 497);
              // Nastratura / Cuciture
              if (hasNastratura) {
                costoNastraturaCuciture = 438;
              }  
              // Grondaie
              if (hasGrondaie) {
                costoGrondaie = numeroGrondaie * 6 * 57.5;  
              }
              // Su misura
              if (ombrelloneSuMisura) {
                costoOmbrellonisuMisura = !hasBase ? numeroOmbrelloni * (4950.0 + (4950.0 * percentageSuMisura)) : numeroOmbrelloni * ((4950.0 + 497) + ((4950.0 + 497) * percentageSuMisura));
              }         
            break;
            case E_MisureOmbrelloni._3X5.toString():
              costoOmbrelloni = !hasBase ? numeroOmbrelloni * 3450.5 : numeroOmbrelloni * (3450.5 + 497);
              // Nastratura / Cuciture
              if (hasNastratura) {
                costoNastraturaCuciture = 351;
              }  
              // Grondaie
              if (hasGrondaie) {
                costoGrondaie = numeroGrondaie * 3 * 57.5;  
              }
              // Su misura
              if (ombrelloneSuMisura) {
                costoOmbrellonisuMisura = !hasBase ? numeroOmbrelloni * (3520.0 + (3520.0 * percentageSuMisura)) : numeroOmbrelloni * (3520.0 + 497) + ((3520.0 + 497) * percentageSuMisura);
              }          
            break;
            case E_MisureOmbrelloni._3X6.toString():
              costoOmbrelloni = !hasBase ? numeroOmbrelloni * 4280.0 : numeroOmbrelloni * (4280.0 + 497);
              // Nastratura / Cuciture
              if (hasNastratura) {
                costoNastraturaCuciture = 439;
              } 
              // Grondaie
              if (hasGrondaie) {
                costoGrondaie = numeroGrondaie * 3 * 57.5;
              }
              // Su misura
              if (ombrelloneSuMisura) {
                costoOmbrellonisuMisura = !hasBase ? numeroOmbrelloni * 4360.0 + (4360.0 * percentageSuMisura) : numeroOmbrelloni * ((4360.0 + 497) + ((4360.0 + 497) * percentageSuMisura));
              }      
            break;    
            case E_MisureOmbrelloni._3X7.toString():
              costoOmbrelloni = !hasBase ? numeroOmbrelloni * 4450.0 : numeroOmbrelloni * (4450.0 + 497);
              // Nastratura / Cuciture
              if (hasNastratura) {
                costoNastraturaCuciture = 527;
              } 
              // Grondaie
              if (hasGrondaie) {
                costoGrondaie = numeroGrondaie * 3 * 57.5;  
              }
              // Su misura
              if (ombrelloneSuMisura) {
                costoOmbrellonisuMisura = !hasBase ? numeroOmbrelloni * (4620.0 + (4620.0 * percentageSuMisura)) : numeroOmbrelloni * ((4620.0 + 497) + ((4620.0 + 497) * percentageSuMisura));
              }          
            break;      
            case E_MisureOmbrelloni._3mX5.toString():
              costoOmbrelloni = !hasBase ? numeroOmbrelloni * 3600.0 : numeroOmbrelloni * (3600.0 + 497);
              // Nastratura / Cuciture
              if (hasNastratura) {
                costoNastraturaCuciture = 438;
              } 
              // Grondaie
              if (hasGrondaie) {
                costoGrondaie = numeroGrondaie * 3.5 * 57.5;  
              }
              // Su misura
              if (ombrelloneSuMisura) {
                costoOmbrellonisuMisura = !hasBase ? numeroOmbrelloni * (3740.0 + (3740.0 * percentageSuMisura)) : numeroOmbrelloni * ((3740.0 + 497) + ((3740.0 + 497) * percentageSuMisura));
              }      
            break;  
            case E_MisureOmbrelloni._4X5.toString():
              costoOmbrelloni = !hasBase ? numeroOmbrelloni * 3520.0 : numeroOmbrelloni * (3520.0 + 497);
              // Nastratura / Cuciture
              if (hasNastratura) {
                costoNastraturaCuciture = 438;
              } 
              // Grondaie
              if (hasGrondaie) {
                costoGrondaie = numeroGrondaie * 4 * 57.5;
              }
              // Su misura
              if (ombrelloneSuMisura) {
                costoOmbrellonisuMisura = !hasBase ? numeroOmbrelloni * (3600.0 + (3600.0 * percentageSuMisura)) : numeroOmbrelloni * ((3600.0 + 497) + ((3600.0 + 497) * percentageSuMisura));
              }      
            break;       
            case E_MisureOmbrelloni._4X6.toString():
              costoOmbrelloni = !hasBase ? numeroOmbrelloni * 4180.0 : numeroOmbrelloni * (4180.0 + 497);
              // Nastratura / Cuciture
              if (hasNastratura) {
                costoNastraturaCuciture = 438;
              }  
              // Grondaie
              if (hasGrondaie) {
                costoGrondaie = numeroGrondaie * 4 * 57.5;  
              }
              // Su misura
              if (ombrelloneSuMisura) {
                costoOmbrellonisuMisura = !hasBase ? numeroOmbrelloni * (4280.0 + (4280.0 * percentageSuMisura)) : numeroOmbrelloni * ((4280.0 + 497) + ((4280.0 + 497) * percentageSuMisura));
              }     
            break;       
            case E_MisureOmbrelloni._4mX5m.toString():
              costoOmbrelloni = !hasBase ? numeroOmbrelloni * 4150.0 : numeroOmbrelloni * (4150.0 + 497);
              // Nastratura / Cuciture
              if (hasNastratura) {
                costoNastraturaCuciture = 351;
              } 
              // Grondaie
              if (hasGrondaie) {
                costoGrondaie = numeroGrondaie * 4.5 * 57.5;  
              }
              // Su misura
              if (ombrelloneSuMisura) {
                costoOmbrellonisuMisura = !hasBase ? numeroOmbrelloni * (4180.0 + (4180.0 * percentageSuMisura)) : numeroOmbrelloni * ((4180.0 + 497) + ((4180.0 + 497) * percentageSuMisura));
              }     
            break;       
            case E_MisureOmbrelloni._5X6.toString():
              costoOmbrelloni = !hasBase ? numeroOmbrelloni * 4360.0 : numeroOmbrelloni * (4360.0 + 497);
              // Nastratura / Cuciture
              if (hasNastratura) {
                costoNastraturaCuciture = 525;
              }  
              // Grondaie
              if (hasGrondaie) {
                costoGrondaie = numeroGrondaie * 5 * 57.5;
              }
              // Su misura
              if (ombrelloneSuMisura) {
                costoOmbrellonisuMisura = !hasBase ? numeroOmbrelloni * (4450.0 + (4450.0 * percentageSuMisura)) : numeroOmbrelloni * ((4450.0 + 497) + ((4450.0 + 497) * percentageSuMisura));
              }         
            break;       
            case E_MisureOmbrelloni._5X7.toString():
              costoOmbrelloni = !hasBase ? numeroOmbrelloni * 4950.0 : numeroOmbrelloni * (4950.0 + 497);
              // Nastratura / Cuciture
              if (hasNastratura) {
                costoNastraturaCuciture = 525;
              } 
              // Grondaie
              if (hasGrondaie) {
                costoGrondaie = numeroGrondaie * 5 * 57.5;  
              }
              // Su misura
              if (ombrelloneSuMisura) {
                costoOmbrellonisuMisura = !hasBase ? numeroOmbrelloni * 4950.0 : numeroOmbrelloni * (4950.0 + 497);
              }          
            break;                
          }  
        }
        break;       
        case E_TipoOmbrellone.Roma.toString(): {
          const percentageSuMisura = 0.20;
          switch (misureOmbrelloni.toString()) {
            case E_MisureOmbrelloni._2X3.toString():         
              costoOmbrelloni = !hasBase ? numeroOmbrelloni * 1300.0 : numeroOmbrelloni * (1300.0 + 189);
              // Nastratura / Cuciture
              if (hasNastratura) {
                costoNastraturaCuciture = 174;
              } 
              // Grondaie
              if (hasGrondaie) {
                costoGrondaie = numeroGrondaie * 2 * 57.5;  
              }
              // Su misura
              if (ombrelloneSuMisura) {
                costoOmbrellonisuMisura = !hasBase ? numeroOmbrelloni * (1420.0 + (1420.0 * percentageSuMisura)) : numeroOmbrelloni * ((1420.0 + 189) + ((1420.0 + 189) * percentageSuMisura));
              }         
            break;
            case E_MisureOmbrelloni._3X3.toString():
              costoOmbrelloni = !hasBase ? numeroOmbrelloni * 1420.0 : numeroOmbrelloni * (1420.0 + 189);
              // Nastratura / Cuciture
              if (hasNastratura) {
                costoNastraturaCuciture = 263;
              } 
              // Grondaie
              if (hasGrondaie) {
                costoGrondaie = numeroGrondaie * 3 * 57.5;
              }
              // Su misura
              if (ombrelloneSuMisura) {
                costoOmbrellonisuMisura = !hasBase ? numeroOmbrelloni * (1590.0 + (1590.0 * percentageSuMisura)) : numeroOmbrelloni * ((1590.0 + 189) + ((1590.0 + 189) * percentageSuMisura));
              }        
            break;
            case E_MisureOmbrelloni._2X4.toString():
              costoOmbrelloni = !hasBase ? numeroOmbrelloni * 1420.5 : numeroOmbrelloni * (1420.5 + 189);
              // Nastratura / Cuciture
              if (hasNastratura) {
                costoNastraturaCuciture = 263;
              } 
              // Grondaie
              if (hasGrondaie) {
                costoGrondaie = numeroGrondaie * 2 * 57.5;  
              }
              // Su misura
              if (ombrelloneSuMisura) {
                costoOmbrellonisuMisura = !hasBase ? numeroOmbrelloni * (1590.0 + (1590.0 * percentageSuMisura)) : numeroOmbrelloni * ((1590.0 + 189) + ((1590.0 + 189) * percentageSuMisura));
              }        
            break;
            case E_MisureOmbrelloni._3X4.toString():
              costoOmbrelloni = !hasBase ? numeroOmbrelloni * 1590.5 : numeroOmbrelloni * (1590.5 + 189);
              // Nastratura / Cuciture
              if (hasNastratura) {
                costoNastraturaCuciture = 263;
              } 
              // Grondaie
              if (hasGrondaie) {
                costoGrondaie = numeroGrondaie * 3 * 57.5;
              }
              // Su misura
              if (ombrelloneSuMisura) {
                costoOmbrellonisuMisura = !hasBase ? numeroOmbrelloni * 1590.5 : numeroOmbrelloni * (1590.5 + 189);
              }        
            break;              
          }  
        }
        break;       
        case E_TipoOmbrellone.PratiqueContract.toString(): {
          switch (misureOmbrelloni.toString()) {
            case E_MisureOmbrelloni._2X3.toString():         
              costoOmbrelloni = !hasBase ? numeroOmbrelloni * 2440.0 : numeroOmbrelloni * (2440.0 + 205);
              // Nastratura / Cuciture
              if (hasNastratura) {
                costoNastraturaCuciture = 174;
              } 
              // Grondaie
              if (hasGrondaie) {
                costoGrondaie = numeroGrondaie * 2 * 57.5;  
              }
              // Su misura
              if (ombrelloneSuMisura) {
                costoOmbrellonisuMisura = !hasBase ? numeroOmbrelloni * 2440.0 : numeroOmbrelloni * (2440.0 + 205);
              }          
            break;
            case E_MisureOmbrelloni._3X3.toString():
              costoOmbrelloni = !hasBase ? numeroOmbrelloni * 2633.0 : numeroOmbrelloni * (2633.0 + 205);
              // Nastratura / Cuciture
              if (hasNastratura) {
                costoNastraturaCuciture = 263;
              } 
              // Grondaie
              if (hasGrondaie) {
                costoGrondaie = numeroGrondaie * 3 * 57.5;
              }
              // Su misura
              if (ombrelloneSuMisura) {
                costoOmbrellonisuMisura = !hasBase ? numeroOmbrelloni * 2633.0 : numeroOmbrelloni * (2633.0 + 205);
              }          
            break;
            case E_MisureOmbrelloni._3X4.toString():
              costoOmbrelloni = !hasBase ? numeroOmbrelloni * 3061.5 : numeroOmbrelloni * (3061.5 + 205);
              // Nastratura / Cuciture
              if (hasNastratura) {
                costoNastraturaCuciture = 263;
              } 
              // Grondaie
              if (hasGrondaie) {
                costoGrondaie = numeroGrondaie * 3 * 57.5;  
              }
              // Su misura
              if (ombrelloneSuMisura) {
                costoOmbrellonisuMisura = !hasBase ? numeroOmbrelloni * 3061.5 : numeroOmbrelloni * (3061.5 + 205);
              }          
            break;                        
          }  
        }
        break;   
        case E_TipoOmbrellone.PratiqueClassic.toString(): {
          const percentageSuMisura = 0.30;
          switch (misureOmbrelloni.toString()) {
            case E_MisureOmbrelloni._2X3.toString():         
              costoOmbrelloni = !hasBase ? numeroOmbrelloni * 2711.0 : numeroOmbrelloni * (2711.0 + 298.5);
              // Nastratura / Cuciture
              if (hasNastratura) {
                costoNastraturaCuciture = 174;
              } 
              // Grondaie
              if (hasGrondaie) {
                costoGrondaie = numeroGrondaie * 2 * 57.5;  
              }
              // Su misura
              if (ombrelloneSuMisura) {
                costoOmbrellonisuMisura = !hasBase ? numeroOmbrelloni * (2925.5 + (2925.5 * percentageSuMisura)) : numeroOmbrelloni * ((2925.5 + 298.5) + ((2925.5 + 298.5) * percentageSuMisura));
              }          
            break;
            case E_MisureOmbrelloni._3X3.toString():
              costoOmbrelloni = !hasBase ? numeroOmbrelloni * 2925.5 : numeroOmbrelloni * (2925.5 + 298.5);
              // Nastratura / Cuciture
              if (hasNastratura) {
                costoNastraturaCuciture = 263;
              } 
              // Grondaie
              if (hasGrondaie) {
                costoGrondaie = numeroGrondaie * 3 * 57.5;  
              }
              // Su misura
              if (ombrelloneSuMisura) {
                costoOmbrellonisuMisura = !hasBase ? numeroOmbrelloni * (3401.5 + (3401.5 * percentageSuMisura)) : numeroOmbrelloni * ((3401.5 + 298.5) + ((3401.5 + 298.5) * percentageSuMisura));
              }      
            break;
            case E_MisureOmbrelloni._3X4.toString():
              costoOmbrelloni = !hasBase ? numeroOmbrelloni * 3401.5 : numeroOmbrelloni * (3401.5 + 298.5);
              // Nastratura / Cuciture
              if (hasNastratura) {
                costoNastraturaCuciture = 263;
              } 
              // Grondaie
              if (hasGrondaie) {
                costoGrondaie = numeroGrondaie * 3 * 57.5;  
              }
              // Su misura
              if (ombrelloneSuMisura) {
                costoOmbrellonisuMisura = !hasBase ? numeroOmbrelloni * (4141.5 + (4141.5 * percentageSuMisura)) : numeroOmbrelloni * ((4141.5 + 298.5) + ((4141.5 + 298.5) * percentageSuMisura));
              }      
            break;     
            case E_MisureOmbrelloni._3mX3m.toString():
              costoOmbrelloni = !hasBase ? numeroOmbrelloni * 3401.5 : numeroOmbrelloni * (3401.5 + 298.5);
              // Nastratura / Cuciture
              if (hasNastratura) {
                costoNastraturaCuciture = 263;
              }
              // Grondaie
              if (hasGrondaie) {
                costoGrondaie = numeroGrondaie * 3.5 * 57.5;   
              }
              // Su misura
              if (ombrelloneSuMisura) {
                costoOmbrellonisuMisura = !hasBase ? numeroOmbrelloni * (4141.5 + (4141.5 * percentageSuMisura)) : numeroOmbrelloni * ((4141.5 + 298.5) + ((4141.5 + 298.5) * percentageSuMisura));
              }       
            break;        
            case E_MisureOmbrelloni._4X4.toString():
              costoOmbrelloni = !hasBase ? numeroOmbrelloni * 4141.5 : numeroOmbrelloni * (4141.5 + 298.5);
              // Nastratura / Cuciture
              if (hasNastratura) {
                costoNastraturaCuciture = 263;
              } 
              // Grondaie
              if (hasGrondaie) {
                costoGrondaie = numeroGrondaie * 4 * 57.5;    
              }
              // Su misura
              if (ombrelloneSuMisura) {
                costoOmbrellonisuMisura = !hasBase ? numeroOmbrelloni * 4141.5 : numeroOmbrelloni * (4141.5 + 298.5);
              }      
            break;                           
          }  
        }
        break;   
        case E_TipoOmbrellone.Diffusion.toString(): {         
          switch (misureOmbrelloni.toString()) {
            case E_MisureOmbrelloni._2X2.toString():         
              costoOmbrelloni = coloreMetallo.toString() === E_ColoriMetallo.Antracite ? (!hasBase ? numeroOmbrelloni * 1200.0 : numeroOmbrelloni * (1200.0 + 189)) : (!hasBase ? numeroOmbrelloni * 1200.0 : numeroOmbrelloni * (1200.0 + 189));
              // Nastratura / Cuciture
              if (hasNastratura) {
                costoNastraturaCuciture = 174;
              }  
              // Grondaie
              if (hasGrondaie) {
                costoGrondaie = numeroGrondaie * 2 * 57.5;     
              }
              // Su misura
              if (ombrelloneSuMisura) {
                costoOmbrellonisuMisura = coloreMetallo.toString() === E_ColoriMetallo.Antracite ? (!hasBase ? numeroOmbrelloni * 1200.0 : numeroOmbrelloni * (1200.0 + 189)) : (!hasBase ? numeroOmbrelloni * 1200.0 : numeroOmbrelloni * (1200.0 + 189));
              }   
            break;
            case E_MisureOmbrelloni._2X2m.toString():
              costoOmbrelloni = coloreMetallo.toString() === E_ColoriMetallo.Antracite ? (!hasBase ? numeroOmbrelloni * 1300.0 : numeroOmbrelloni * (1300.0 + 189)) : (!hasBase ? numeroOmbrelloni * 1320.0 : numeroOmbrelloni * (1320.0 + 189));
              // Nastratura / Cuciture
              if (hasNastratura) {
                costoNastraturaCuciture = 174;
              } 
              // Grondaie
              if (hasGrondaie) {
                costoGrondaie = numeroGrondaie * 2 * 57.5;      
              }
              // Su misura
              if (ombrelloneSuMisura) {
                costoOmbrellonisuMisura = coloreMetallo.toString() === E_ColoriMetallo.Antracite ? (!hasBase ? numeroOmbrelloni * 1300.0 : numeroOmbrelloni * (1300.0 + 189)) : (!hasBase ? numeroOmbrelloni * 1320.0 : numeroOmbrelloni * (1320.0 + 189));
              }    
            break;
            case E_MisureOmbrelloni._2X3.toString():
              costoOmbrelloni = coloreMetallo.toString() === E_ColoriMetallo.Antracite ? (!hasBase ? numeroOmbrelloni * 1300.0 : numeroOmbrelloni * (1300.0 + 189)) : (!hasBase ? numeroOmbrelloni * 1320.0 : numeroOmbrelloni * (1320.0 + 189));
              // Nastratura / Cuciture
              if (hasNastratura) {
                costoNastraturaCuciture = 174;
              } 
              // Grondaie
              if (hasGrondaie) {
                costoGrondaie = numeroGrondaie * 2 * 57.5;     
              }
              // Su misura
              if (ombrelloneSuMisura) {
                costoOmbrellonisuMisura = coloreMetallo.toString() === E_ColoriMetallo.Antracite ? (!hasBase ? numeroOmbrelloni * 1300.0 : numeroOmbrelloni * (1300.0 + 189)) : (!hasBase ? numeroOmbrelloni * 1320.0 : numeroOmbrelloni * (1320.0 + 189));
              }    
            break;     
            case E_MisureOmbrelloni._2X3m.toString():
              costoOmbrelloni = coloreMetallo.toString() === E_ColoriMetallo.Antracite ? (!hasBase ? numeroOmbrelloni * 1420.0 : numeroOmbrelloni * (1420.0 + 189)) : (!hasBase ? numeroOmbrelloni * 1450.0 : numeroOmbrelloni * (1450.0 + 189));
              // Nastratura / Cuciture
              if (hasNastratura) {
                costoNastraturaCuciture = 263;
              }  
              // Grondaie
              if (hasGrondaie) {
                costoGrondaie = numeroGrondaie * 2 * 57.5;  
              }
              // Su misura
              if (ombrelloneSuMisura) {
                costoOmbrellonisuMisura = coloreMetallo.toString() === E_ColoriMetallo.Antracite ? (!hasBase ? numeroOmbrelloni * 1420.0 : numeroOmbrelloni * (1420.0 + 189)) : (!hasBase ? numeroOmbrelloni * 1450.0 : numeroOmbrelloni * (1450.0 + 189));
              }   
            break;        
            case E_MisureOmbrelloni._3X3.toString():
              costoOmbrelloni = coloreMetallo.toString() === E_ColoriMetallo.Antracite ? (!hasBase ? numeroOmbrelloni * 1420.0 : numeroOmbrelloni * (1420.0 + 189)) : (!hasBase ? numeroOmbrelloni * 1450.0 : numeroOmbrelloni * (1450.0 + 189));
              // Nastratura / Cuciture
              if (hasNastratura) {
                costoNastraturaCuciture = 263;
              }
              // Grondaie
              if (hasGrondaie) {
                costoGrondaie = numeroGrondaie * 3 * 57.5;  
              }
              // Su misura
              if (ombrelloneSuMisura) {
                costoOmbrellonisuMisura = coloreMetallo.toString() === E_ColoriMetallo.Antracite ? (!hasBase ? numeroOmbrelloni * 1420.0 : numeroOmbrelloni * (1420.0 + 189)) : (!hasBase ? numeroOmbrelloni * 1450.0 : numeroOmbrelloni * (1450.0 + 189));
              }     
            break;     
            case E_MisureOmbrelloni._3X4.toString():
              costoOmbrelloni = coloreMetallo.toString() === E_ColoriMetallo.Antracite ? (!hasBase ? numeroOmbrelloni * 1590.0 : numeroOmbrelloni * (1590.0 + 189)) : (!hasBase ? numeroOmbrelloni * 1620.0 : numeroOmbrelloni * (1620.0 + 189));
              // Nastratura / Cuciture
              if (hasNastratura) {
                costoNastraturaCuciture = 263;
              }
              // Grondaie
              if (hasGrondaie) {
                costoGrondaie = numeroGrondaie * 3 * 57.5;    
              }
              // Su misura
              if (ombrelloneSuMisura) {
                costoOmbrellonisuMisura = coloreMetallo.toString() === E_ColoriMetallo.Antracite ? (!hasBase ? numeroOmbrelloni * 1590.0 : numeroOmbrelloni * (1590.0 + 189)) : (!hasBase ? numeroOmbrelloni * 1620.0 : numeroOmbrelloni * (1620.0 + 189));
              }     
            break;                              
          }  
        }  
        break;         
      }
    }   
  } 
  // Costo velcro
  if (hasVelcro) {
    costoVelcro = 17 * lunghezzaParavento;
  }
  // Costo led
  if (hasLed) {
    if (tipoKitLed.toString() === E_KitLedOmbrelloni.kit0_5m.toString()) {
      costoLed = numeroOmbrelloni * 589;
    } else if (tipoKitLed.toString() === E_KitLedOmbrelloni.kit1m.toString()) {    
      costoLed = numeroOmbrelloni * (!hasDimmerTel ? 1159 : 1382.5);
    } else if (tipoKitLed.toString() === E_KitLedOmbrelloni.kit2m.toString()) {
      costoLed = numeroOmbrelloni * (!hasDimmerTel ? 1666 : 2245);
    }
  }
  return costoPredisposizioneOmbrelloni + (!ombrelloneSuMisura ? costoOmbrelloni : costoOmbrellonisuMisura) + costoNastraturaCuciture + costoGrondaie + costoVelcro + costoLed;
}

const calculateCristalTotal = (hasVelcro, latiCristal, numeroSostegni, hasKitPorta, lunghezzaLatiCristal) => {           
  let hasCristal = false;
  latiCristal.forEach(element => {
    if (element.cristal)
      hasCristal = true;
  });
  if (!hasCristal) {
    return 0;
  }
  // Se gli ombrelloni non sono stati selezionati...
  if (!hasVelcro) {
    return 0;
  }
  if (hasCristal) {
    // Laterale Cristal 
    for (let i=0; i<latiCristal.length; i++) {
      if (latiCristal[i].cristal) {
        switch(latiCristal[i].lato.toString()) {
          case E_MainLato.Lato1.toString(): 
            const lato1 = lunghezzaLatiCristal.find(el => el.lato.toString() === E_MainLato.Lato1.toString());
            const lunghezza1 = lato1.lunghezzaCristalSulLato;  
            costoCristal += lunghezza1 * 192.5;
          break;
          case E_MainLato.Lato2.toString():
            const lato2 = lunghezzaLatiCristal.find(el => el.lato.toString() === E_MainLato.Lato2.toString());
            const lunghezza2 = lato2.lunghezzaCristalSulLato;    
            costoCristal += lunghezza2 * 192.5;
          break;
          case E_MainLato.Lato3.toString():
            const lato3 = lunghezzaLatiCristal.find(el => el.lato.toString() === E_MainLato.Lato3.toString());
            const lunghezza3 = lato3.lunghezzaCristalSulLato;          
            costoCristal += lunghezza3 * 192.5;
          break;
          case E_MainLato.Lato4.toString():
            const lato4 = lunghezzaLatiCristal.find(el => el.lato.toString() === E_MainLato.Lato4.toString());
            const lunghezza4 = lato4.lunghezzaCristalSulLato;       
            costoCristal += lunghezza4 * 192.5;
          break;   
          default:
            costoCristal += 0;
          break;
        }
      }
    }
    costoSostegniCristal = numeroSostegni * 153;
    // Porta laterale Cristal
    if (hasKitPorta) {
      costoKitPorta = 250;
    }
    return costoCristal + costoSostegniCristal + costoKitPorta;
  }    
}

const Compute = (
  isPedanaSelected,
  isParaventiSelected,
  isOmbrelloniSelected,
  isCristalSelected,
  lunghezza,
  larghezza,
  pedanaStepAltezza, 
  pedanaRivestimento, 
  pedanaHasMinigonna, 
  pedanaHasRampaDisabili, 
  pedanaHasPredParaventi,
  pedanaBotole,
  paraventiLunghezza,
  paraventiTipo,
  paraventiKitPorta,
  ombrelloniNumero,
  ombrelloniTipo,
  ombrelloniHasMisuraAutomatica,
  ombrelloniMisure,
  ombrelloniMisureAutomatiche,
  ombrelloniHasGrondaie,
  ombrelloniHasNastratura,
  ombrelloniHasVelcro,
  ombrelloniData,
  ombrelloniColoreMetallo,
  cristalLati,
  lunghezzaLatiCristal,
  cristalNumeroSostegni,
  cristalHasKitPorta,
  ombrelloniHasLed, 
  ombrelloniTipoKitLed,
  ombrelloniHasDimmerTel, 
  ombrelloniNumeroGrondaie
  ) => {  
    // Resetta a zero prima del calcolo totale
    Clear();

    perimetro = CalculatePerimeter(lunghezza * 1, larghezza * 1);
    area = CalculateArea(lunghezza * 1, larghezza * 1);    

    importoTotale =
    // Calcola il costo della pedana se è selezionata
    (isPedanaSelected && calculatePedanaTotal(area, perimetro, pedanaStepAltezza, pedanaRivestimento, pedanaHasMinigonna, pedanaHasRampaDisabili, pedanaHasPredParaventi, pedanaBotole, paraventiLunghezza)) +
    // Calcola il costo dei paraventi se sono selezionati
    (isParaventiSelected && calculateParaventiTotal(paraventiLunghezza, paraventiTipo, paraventiKitPorta)) +
    // Calcola il costo degli ombrelloni se sono selezionati
    (isOmbrelloniSelected && calculateOmbrelloniTotal(ombrelloniNumero, ombrelloniTipo, !isPedanaSelected, ombrelloniHasMisuraAutomatica ? ombrelloniMisureAutomatiche : ombrelloniMisure, ombrelloniHasGrondaie, ombrelloniHasNastratura, ombrelloniHasVelcro, ombrelloniHasMisuraAutomatica, ombrelloniData, ombrelloniColoreMetallo, paraventiLunghezza, ombrelloniHasLed, ombrelloniTipoKitLed, ombrelloniHasDimmerTel, ombrelloniNumeroGrondaie)) +
    // Calcola il costo lei laterali Cristal se sono selezionati
    (isCristalSelected && calculateCristalTotal(ombrelloniHasVelcro, cristalLati, cristalNumeroSostegni, cristalHasKitPorta, lunghezzaLatiCristal));     

    // console.log (`Costo sottoscocca: ${costoSottoscocca}`);
    // console.log (`Costo rivestimento: ${costoRivestimento}`);  
    // console.log (`Costo minigonna: ${costoMinigonna}`);
    // console.log (`Costo rampa: ${costoRampaDisabili}`);
    // console.log (`Costo pred. paraventi: ${costoPredParaventi}`);
    // console.log (`Costo paraventi: ${costoParaventi}`);
    // console.log (`Costo porte paraventi: ${costoPorteParaventi}`);
    // console.log (`Costo botole: ${costoBotole}`);
    // console.log (`Costo pred. ombrelloni: ${costoPredisposizioneOmbrelloni}`);
    // console.log (`Costo ombrelloni: ${costoOmbrelloni}`);
    // console.log (`Costo ombrelloni su misura: ${costoOmbrellonisuMisura}`);
    // console.log (`Costo nastratura: ${costoNastraturaCuciture}`);
    // console.log (`Costo grondaie: ${costoGrondaie}`);
    // console.log (`Costo velcro: ${costoVelcro}`);
    // console.log (`Costo cristal: ${costoCristal}`); 
    // console.log (`Costo sostegni cristal: ${costoSostegniCristal}`);
    // console.log (`Costo kit porta: ${costoKitPorta}`);
    // console.log (`Totale: ${importoTotale}`);
    // console.log (`------------------------------------------------------------`);
 
    return importoTotale;  
  };
  
const CalculateArea = (lunghezza, larghezza) => {
  return lunghezza * larghezza;
};

const CalculatePerimeter = (lunghezza, larghezza) => {
  return 2 * lunghezza + 2 * larghezza;
};

const GetPartialImpots = () => {
  return {
    sottoscocca: costoSottoscocca,
    rivestimento: costoRivestimento,    
    minigonna: costoMinigonna,
    rampa: costoRampaDisabili,
    predParaventi: costoPredParaventi,
    paraventi: costoParaventi,
    porteParaventi:costoPorteParaventi,
    botole: costoBotole,
    predOmbrelloni: costoPredisposizioneOmbrelloni,
    ombrelloni: costoOmbrelloni,
    ombrelloniSuMisura: costoOmbrellonisuMisura,
    nastratura: costoNastraturaCuciture,
    grondaie: costoGrondaie,
    velcro: costoVelcro,
    cristal: costoCristal,
    sostegniCristal: costoSostegniCristal,
    kitPortaCristal: costoKitPorta, 
    led: costoLed,
  }
}

export { Compute, Clear, GetPartialImpots };
